<app-loader *ngIf="loaderIcon | async"></app-loader>
<div [ngClass]="isAdmin ? 'topHearder topHearder-admin' : 'topHearder topHearder-operation' ">
    <div class="d-flex align-items-center justify-content-start">
        <div class="headLogoContainer">
            <img class="img-fluid large_logo brandingimg" [src]="companySettingBrandingLogo" alt="Self Storage Manager" />
        </div>
        <app-search-bar class="search-container-wrapper" [customSearchDetails]="compSettingSearchDetails"
            [isESignature]="isESignature" [switchStoreOption]="switchStoreOption"
            [lastAccessedFacility]="lastAccessedFacility" [isGeoLocationBasedLogIn]="isGeoLocationBasedLogIn"
            [userSessionStores]="userSessionStores" (loaderEmitter)="setLoaderIcon($event)">
        </app-search-bar>
    </div>
    <div [ngClass]="isAdmin ? 'd-flex align-items-center justify-content-end tophead-mobile-admin' : 'd-flex align-items-center justify-content-end tophead-mobile' ">

        <div *ngIf="!isAdmin && permissionQuickStart && !isQuickStart"><a routerLink="/prospect/quickstart"
                (click)="setLoaderIcon(true)">
                <i class="fa fa-user-plus_topbar userplus_align"></i></a></div>


        <div class="head_store_name" style="padding-right: 10px !important;">
            <img src="{{facilityLevelLogo}}" height="50px" width="100px" *ngIf="!isAdmin && facilityLevelLogo !=''" />
            <p class="mb-0" #storeNameLabel *ngIf="!isAdmin">{{localLocationObj.Name}}</p>
        </div>
        <app-store-info [localLocationObj]="localLocationObj" [storeInfoFacId]="storeInfoFacId"></app-store-info>

        <div class="profile_sec">
            <div class="head_notify">
                <app-email-bar [isAdmin]="isAdmin" [lastAccessedFacility]="lastAccessedFacility"
                    [toasterConfig]="toasterConfig" [storeNameChange]="storeNameChange" [AdminOrOps]="AdminOrOps"
                    [isCallCenterAgent]="isCallCenterAgent"
                    (initiateDelNotify)="initiateDelNotify($event)"
                    (emailPopup)="showEmails('email_toggle')">
                </app-email-bar>

                <app-phonecall-bar         
                    [isAdmin]="isAdmin" [lastAccessedFacility]="lastAccessedFacility"
                    [toasterConfig]="toasterConfig" [storeNameChange]="storeNameChange" [AdminOrOps]="AdminOrOps"
                    [isCallCenterAgent]="isCallCenterAgent"
                    (initiateDelNotif)="initiateDelNotif($event)"
                    (phonePopup)="showPhoneCalls('phone_toggle')"
                    (phoneToggleClosed)="closePhonePopup()">
                </app-phonecall-bar>
           
                <span class="head_msg msgtogg" (click)="showPopupMessage('message_toggle')" *ngIf="!isAdmin">
                    <i class="chat-icon msgtogg"></i>
                    <small class="msgtogg" *ngIf="smsCount>0">{{smsCount}}</small>
                </span>

            <app-notification-bar [isAdmin]="isAdmin" [lastAccessedFacility]="lastAccessedFacility"
                                  [toasterConfig]="toasterConfig" [storeNameChange]="storeNameChange" [AdminOrOps]="AdminOrOps"
                                  (showNotification)="showPopupNotification('notification_toggle')" (loading)="setLoaderIcon($event)"
                                  [facilityDayendSetting]="facilityDayendSetting"
                                  [facilityLateAndLienSetting]="facilityLateAndLienSetting">
            </app-notification-bar>

                <!-- Start Message Popup -->
                <div class="message-container">
                    <div class="message_outer" *ngIf="MessageList">
                        <div class="message_title">
                            <h3>Messages</h3>
                        </div>
                        <div class="message_list_out">
                            <div *ngFor="let oneSms of smsLists">
                                <div class="message_list" [ngClass]="{'read': oneSms.Read===true}">
                                    <div class="msg_lft_det">
                                        <a (click)="showMsgDetail(oneSms.Id)"><b *ngIf="oneSms.TenantName">{{oneSms.TenantName}}</b>
                                            <b><i class="msg-icon me-1"></i>
                                                <i class="fa-phone-icon"></i>
                                                {{oneSms.FromNumber | phone:1}}</b>
                                            <p>{{oneSms.Message}}</p>
                                        </a>
                                    </div>
                                    <a class="fas fa-times msg_close" (click)="initiateDelConv(oneSms.Id)">&nbsp;</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="message_outer" *ngIf="MessageDetail">
                        <div class="message_title">
                            <h3>{{tenantname}}<br />
                                {{tenantnumber | phone:1}}</h3>
                            <a (click)="HideMsgDetail()" class="fas fa-angle-left back_list"></a>
                        </div>
                        <div class="message_detail_out">
                            <div class="scroll_sec scrollable-container" #scrollMe [scrollTop]="scrollMe.scrollHeight">
                                <div *ngFor="let msg of filteredLogs">
                                    <div [ngClass]="{'receiver': msg.Type==368, 'sender': msg.Type==369}">
                                        <div class="date_time"><span>{{msg.FacilityDateTime | date: 'mediumDate'}} &nbsp;&nbsp;
                                                {{msg.FacilityDateTime | date: 'mediumTime'}}</span></div>
                                        <p class="pre-wrap-container">{{msg.Message}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="detail_bot_sec flex-container">
                                <label for="">Template</label>
                                <select class="form-select" [(ngModel)]="selectedTypeId"
                                    (ngModelChange)="onLetterTypeChange($event)">
                                    <option selected disabled value="null">--Select--</option>
                                    <option *ngFor="let Ltype of lettertypelist" [value]="Ltype.Id">{{Ltype.Name}}
                                    </option>
                                </select>
                            </div>

                            <div class="detail_bot_sec">
                                <div class="letter-count text-right">{{smstext.length}}/1000</div>
                                <textarea rows="5" class="form-control mb-3" [(ngModel)]="smstext" maxlength="1000"
                                    style="resize: none;"></textarea>
                                <div class="d-flex justify-content-end">
                                    <div class="form-group button_tooltip">
                                        <button type="button" class="btn btn-primary" [disabled]="!sendSMSAlert" (click)="sendTheSms()">Send</button>
                                        <div class="button_tooltip_modal" *ngIf="!sendSMSAlert">
                                            <p class="mb-0">Please select the SMS checkbox for this Cellphone Number!</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

            </div>
            <!-- End Notification Popup // -->
          </div>

            <a href="javascript:;" class="profile_user_img profiletogg profile_icon"
                (click)="ProfileMenu('profile_toggle')"> </a>
            <span class="admin_mode" *ngIf="isAdmin && !isESignature"> </span>
            <div id="profilecoll">
                <div class="title">
                    <h3>{{UserFname}} {{UserLname}}</h3>
                </div>
                <a href="javascript:;" i18n="@@Pearsonalize" *ngIf="!isESignature" style="display: none;"><i
                        class="fas fa-user-cog"></i> Personalize</a>

                <a href="javascript:;">
                    <button *ngIf="switchStoreOption && !isAuditManagement" i18n="@@SwitchStore" [disabled]="isGeoLocationBasedLogIn"
                        (click)="onclickSwitchStore()"
                        [ngStyle]="{'cursor': isGeoLocationBasedLogIn ? 'not-allowed' : 'pointer' }"><i
                            class="fas fa-toggle-on"></i> Switch Store</button></a>
                <a routerLink='/admin' *ngIf="!isAdmin" i18n="@@Administration"><i class="fas fa-user-lock"></i>
                    Administration</a>
                <a href="javascript:;" (click)='onClickOperationsMode()' *ngIf="(isAdmin || isMarketing || isAuditManagement) && !isESignature"
                    i18n="@@OperationsMode"><i class="fas fa-tools"></i>
                    Operations Mode</a>
                <a href="javascript:;" (click)='goToEsignaturePage()' *ngIf="!isESignature"><i
                        class="fas fa-signature"></i> Capture
                    Signature</a>
                <a  (click)="goToMarketingDashboard()" *ngIf="!isMarketing && !isESignature && (isEnableCampaignTracker || isEnableCallTracker || viewRightTenantMapping || isEnableStorTrack)" i18n="@@Marketing"><i class="fas fa-marketing"></i>
                        Marketing
                </a>
                                <a (click)="goToAuditManagementPage()" *ngIf="!isAuditManagement && !isESignature && isFacilityAuditLicenseEnabled" i18n="@@AuditManagement" class="audit-management-link"><img class="audit-menu-icon" src="assets/icons8-checked-checkbox-48.svg" alt="" aria-hidden="true" />
                    Audit Management
                </a>
                <a href="javascript:;" (click)="openPersonalApiKeyModal($event)" *ngIf="canAccessMCP" i18n="@@PersonalApiKey"><i class="fas fa-key"></i>
                    Personal API Key <span class="badge badge-mcp">MCP</span>
                </a>
                <a href="javascript:;" (click)="logout()" i18n="@@Logout"><i class="fas fa-power-off"></i> Logout</a>
            </div>
        </div>

        <div [ngClass]="hideNews ? 'hide_news' : isMarketingnews ? 'news_section mrkt_news_section' : isMarketingtenantmap ? 'hide_news' : 'news_section' " *ngIf="getnewsInfo()">
            <marquee onmouseover="this.stop()" onmouseout="this.start();" data-toggle="modal" data-backdrop="static"
                data-keyboard="false"><span *ngFor='let item of newslist' (click)="getnewsSubject.next(item.NewsID)"
                    style="cursor: pointer;">{{item.NewsName}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></marquee>

        </div>
    </div>
</div>

<app-switch-store [storeList]="userSessionStores" [lastAccessed]="lastAccessedFacility"
    (storeChanged)="StoreChanged($event)"></app-switch-store>

<div class="containerForRemoveNotify" (click)="removeNotify_pop()"></div>

<!-- Delete conversation popup -->
<div class="modal fade" id="DeleteConversactionModal" tabindex="-1" role="dialog">
    <div class="modal-dialog  alert_box modal-dialog-centered" role="document">
        <div class="modal-content">
            <ng-template #DeleteConversactionModal>
                <div class="modal-header">
                    <h5 class="modal-title">Delete Conversation</h5>
                    <button type="button" class="close" (click)="cancelDelete()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-center">
                    <p>Are you sure you want to Delete the Conversation?</p>
                    <div class="d-flex mt-3 justify-content-center">
                        <button type="button" class="btn btn-outline-primary w-35 me-3"
                            (click)="cancelDelete()">No</button>
                        <button type="button" class="btn btn-primary w-35" (click)="deleteConversation()">Yes</button>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>

<!--DeleteCall Notification pop up-->
<ng-template #DeleteCallNotificationModal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Call Notification</h5>
    <button type="button" class="close" (click)="cancelDelete()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <p>Are you sure you want to delete this call notification?</p>
    <div class="d-flex mt-3 justify-content-center">
      <button type="button" class="btn btn-outline-primary w-35 me-3" (click)="cancelDelete()"> No</button>
      <button type="button" class="btn btn-primary w-35" (click)="deleteCallNotification()">Yes</button>
    </div>
  </div>
</ng-template>

<!-- News Modal -->
<div class="modal fade" id="NewsModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xxl" role="document">
        <div class="modal-content">
            <ng-template #NewsModal>
                <div class="modal-body news-body">
                    <div class="row mx-0 mt-3 customRichtextEditor">
                        <ejs-richtexteditor class="height400 mt-3" readonly="true" #defaultRTETop [(value)]="newscontent"
                            [toolbarSettings]='toolbarConfig'>
                        </ejs-richtexteditor>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary " (click)="modalRef.hide()">Back</button>
                </div>
            </ng-template>
        </div>
    </div>
</div>

<div class="modal fade" bsModal #showStoreNameModalForGeoLacationLogin="bs-modal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered alert_box" role="document">
        <div class="modal-content">
            <div class="modal-body text-center">
                <h6>You are being logged into {{localLocationObj.Name}}</h6>
            </div>
            <div class="text-center my-3">
                <button class="btn btn-primary px-5" (click)="showStoreNameModalForGeoLacationLogin.hide()">Ok</button>
            </div>
        </div>
    </div>
</div>

<!--DeleteEmail Notification pop up-->
<ng-template #DeleteEmailNotificationModal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Email Notification</h5>
    <button type="button" class="close" (click)="cancelDelete()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <p>Are you sure you want to delete this email notification?</p>
    <div class="d-flex mt-3 justify-content-center">
      <button type="button" class="btn btn-outline-primary w-35 me-3" (click)="cancelDelete()"> No</button>
      <button type="button" class="btn btn-primary w-35" (click)="deleteEmailNotification()">Yes</button>
    </div>
  </div>
</ng-template>
